enum ACTION {
  UPDATE_ANY_KEY = 'UPDATE_ANY_KEY',
}

type State = {
  activePath: string;
  fluidSmallLTE: boolean;
  isFetching: boolean;
};

type DashboardAction = {
  type: ACTION;
  payload: Partial<State>;
};

const INIT_STATE = {
  activePath: '',
  fluidSmallLTE: false,
  isFetching: false,
};

const reducer = (state: State, action: DashboardAction) => {
  const { type, payload } = action;

  switch (type) {
    case ACTION.UPDATE_ANY_KEY: {
      const newState = {
        ...state,
        ...payload,
      };

      return newState;
    }

    default:
      break;
  }
};

// @ts-expect-error
export { ACTION, DashboardAction, State, INIT_STATE };

export default reducer;
